module.exports = __webpack_public_path__ + "img/wind-02.cb79cb45.svg";